<template lang="html">

  <div class="finca-view la-almanzara">

    <section class="banner-intro brown animation full-view-intro column-center" data="la-almanzara">

      <h1 class="title -intro">{{$t('vistas.la_almazara')}}</h1>

      <h2 class="subtitle-intro">{{$t('vistas.la_finca')}}</h2>

    </section>

    <section class="new-texto-imagen row-center ais animation">

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.la_almazara.cuadro_uno.titulo')}}</h2>
        <p v-html="$t('la_tierra.la_almazara.cuadro_uno.texto')"></p>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/la-almanzara/instalaciones.jpg" alt="">
      </div>

    </section>

    
    <section class="new-texto-imagen -inverse row-center ais animation">

      <div class="contenedor-imagen">
        <img src="/static/img/la-almanzara/la-almanzara.jpg" alt="">
      </div>

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.la_almazara.cuadro_dos.titulo')}}</h2>
        <div v-html="$t('la_tierra.la_almazara.cuadro_dos.texto')"></div>
      </div>

    </section>



    <section class="animation imagen-full-texto row-start" data="el-proceso" :id="$t(`slider_proceso.proceso_aceite.id`)">

      <div class="contenedor-texto column-start">

        <h2 class="title">{{$t('la_tierra.la_almazara.proceso.titulo')}}</h2>
        <p>{{$t('la_tierra.la_almazara.proceso.cuerpo')}}</p>
        <router-link :to="$t('enlaces.proceso_aceite')" class="btn -proceso">
          <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
        </router-link>

      </div>

      <div class="enlace-proceso">

        <router-link :to="$t('enlaces.proceso_aceite')" class="btn-container">

          <span class="btn">
            <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
          </span>

        </router-link>

      </div>

    </section>


    <section class="middle-texto-imagen animation row-center ais">


      <div class="texto column-center">

        <div class="container -half">

          <h2 class="title">{{$t('la_tierra.la_almazara.sala_catas.titulo')}}</h2>

          <p>{{$t('la_tierra.la_almazara.sala_catas.cuerpo')}}</p>

          <router-link :to="$t('enlaces.oleoturismo')" class="btn -pc">
            <span>{{$t('la_tierra.la_almazara.sala_catas.boton_large')}}</span>
          </router-link>


          <router-link :to="$t('enlaces.oleoturismo')" class="btn -movil">
            <span>{{$t('la_tierra.la_almazara.sala_catas.boton_short')}}</span>
          </router-link>

        </div>

      </div>

      <div class="contenedor-imagen">
        <div class="imagen" data="cata"></div>
      </div>

    </section>

    <donde-estamos></donde-estamos>

    <otros-lugares></otros-lugares>

            <productos-banner></productos-banner>

    
  </div>

</template>

<script lang="js">


  import otrosLugares from '@/components/parts/otros-lugares';

  import dondeEstamos from '@/components/parts/donde-estamos';

    import productosBanner from '@/components/parts/productos-banner'

  export default  {
    name: 'la-bodega',
    components : {
      'otros-lugares' : otrosLugares,
      'donde-estamos' : dondeEstamos,
       'productos-banner': productosBanner,
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .full-view-intro{
    background: url("/static/img/la-almanzara/background-intro.jpg") center/cover no-repeat;
  }

  .texto-imagen .imagen{
    max-width: 850px;
  }

  .imagen-texto{
    min-height: 560px;
  }

  .imagen-full-texto[data="el-proceso"]{
    background: url("/static/img/la-almanzara/el-proceso.jpg") center/cover no-repeat;
  }

  .imagen[data="la-almanzara"]{
    background: url("") center/cover no-repeat;
  }

  .imagen[data="instalaciones"]{
    background: url("") center/cover no-repeat;
  }

  .imagen[data="cata"]{
   background: url("/static/img/la-almanzara/cata.jpg") center/cover no-repeat; 
 }


 @media screen and (max-width: 1200px){
  .imagen-texto{
    min-height: 0;
    padding: 350px 0 70px 0;
  }
}

@media screen and (max-width: 1100px){
  .texto-imagen.animation.launched .contenedor-imagen{
    transform: translate(0,-150px);
  }
  
  .imagen-texto{
    padding: 100px 0;
  }

  .imagen-texto .textos{
    width: 50%;
    padding-left: 25px;
    padding-right: 0;
  }
}


@media screen and (max-width: 1023px){
  .texto-imagen.animation.launched .contenedor-imagen{
    transform: translate(0,-150px);
  }
  
  .imagen-texto{
    padding-top: 230px;
    padding-bottom: 50px;
  }

  .imagen-texto .textos{
    width: 100%;
    padding-left: 0px;
    padding-right: 0;
  }
}




</style>



// WEBPACK FOOTER //
// src/components/views/la-almanzara/la-almanzara.vue